import { render, staticRenderFns } from "./ModalQuestionOrder.vue?vue&type=template&id=2a801c27&"
import script from "./ModalQuestionOrder.vue?vue&type=script&lang=js&"
export * from "./ModalQuestionOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports